module.exports = __webpack_public_path__ + "pf.d6017afe6815faecd979.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/1x1/pf.svg
// module id = ../../../../flag-icon-css/flags/1x1/pf.svg
// module chunks = styles